enum ROUTES {
  MESSAGES = '/messages',
  MESSAGES_MAIN = '/messages/main-chat',
  MESSAGES_MAIN_UNREAD = '/messages/main-chat/unread',
  MESSAGES_MAIN_UNREAD_MESSAGE = '/messages/main-chat/unread/:messageId',
  MESSAGES_MAIN_IN_PROGRESS = '/messages/main-chat/in-progress',
  MESSAGES_MAIN_IN_PROGRESS_MESSAGE = '/messages/main-chat/in-progress/:messageId',
  MESSAGES_MAIN_COMPLETED = '/messages/main-chat/completed',
  MESSAGES_MAIN_COMPLETED_MESSAGE = '/messages/main-chat/completed/:messageId',
  MESSAGES_MAIN_ALL = '/messages/main-chat/all',
  MESSAGES_MAIN_ALL_MESSAGE = '/messages/main-chat/all/:messageId',
  MESSAGES_REQUEST = '/messages/requests',
  MESSAGES_REQUEST_UNREAD = '/messages/requests/unread',
  MESSAGES_REQUEST_UNREAD_MESSAGE = '/messages/requests/unread/:messageId',
  MESSAGES_REQUEST_IN_PROGRESS = '/messages/requests/in-progress',
  MESSAGES_REQUEST_IN_PROGRESS_MESSAGE = '/messages/requests/in-progress/:messageId',
  MESSAGES_REQUEST_COMPLETED = '/messages/requests/completed',
  MESSAGES_REQUEST_COMPLETED_MESSAGE = '/messages/requests/completed/:messageId',
  MESSAGES_REQUEST_ALL = '/messages/requests/all',
  MESSAGES_REQUEST_ALL_MESSAGE = '/messages/requests/all/:messageId',
}

export default ROUTES;
